import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Send, Linkedin, Twitter } from 'lucide-react';
import { topics } from '../mock';
import Logo from './Logo';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    setSent(true);
    setEmail('');
    setTimeout(() => setSent(false), 3500);
  };

  return (
    <footer className="bg-[#111111] text-[#ffffff]">
      <div className="section-pad pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <h3 className="font-display text-4xl md:text-5xl leading-[1.05] max-w-md">
              The energy transition, decoded every month.
            </h3>
            <form onSubmit={submit} className="mt-8 max-w-md">
              <div className="flex items-center gap-2 border-b border-white/25 pb-2 focus-within:border-[#D01919] transition-colors">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="flex-1 bg-transparent outline-none text-[#ffffff] placeholder:text-white/40 py-2"
                  required
                />
                <button type="submit" className="text-[#D01919] flex items-center gap-1 font-medium">
                  <Send size={17} />
                </button>
              </div>
              <p className="text-sm text-white/50 mt-3">
                {sent ? 'Thanks — check your inbox to confirm.' : 'Join 120,000+ energy leaders. No spam, unsubscribe anytime.'}
              </p>
            </form>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="eyebrow text-[#D01919] mb-4">Topics</p>
              <ul className="space-y-2.5">
                {topics.slice(0, 5).map((t) => (
                  <li key={t.slug}>
                    <Link to="/magazine" className="text-white/70 hover:text-white transition-colors text-[0.95rem]">
                      {t.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="eyebrow text-[#D01919] mb-4">Explore</p>
              <ul className="space-y-2.5">
                {[['Magazine', '/magazine'], ['Events', '/events'], ['One Club', '/club'], ['About', '/about'], ['Contact', '/contact']].map(([l, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-white/70 hover:text-white transition-colors text-[0.95rem]">{l}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="eyebrow text-[#D01919] mb-4">Bureaus</p>
              <ul className="space-y-2.5 text-white/70 text-[0.95rem]">
                <li>New Delhi</li>
                <li>London</li>
                <li>Abu Dhabi</li>
                <li>New York</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-8">
          <div className="flex items-center gap-2">
            <Logo light className="text-2xl" />
          </div>
          <p className="text-white/50 text-sm">© {new Date().getFullYear()} Enersider Markets Media. All rights reserved.</p>
          <div className="flex gap-5 text-sm text-white/60">
            <a href="https://www.linkedin.com/showcase/enersider/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="hover:text-white transition-colors flex items-center gap-1.5"><Linkedin size={16} /> LinkedIn</a>
            <a href="https://x.com/EnersiderMedia/" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" className="hover:text-white transition-colors flex items-center gap-1.5"><Twitter size={16} /> X</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
